import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';

import { searchLocations, joinStockistWaitlist } from '../../../../actions';
import CustomInput from '../../../forms/CustomInput';
import { Link } from 'react-router-dom';
import { MapPinIcon } from '@heroicons/react/24/outline';

const FindLocal = ({
  local,
  searchLocations,
  joinStockistWaitlist,
  make,
  profileGeo,
  itemId,
  itemName,
}) => {
  const [location, setLocation] = useState({});
  const [mount, setMount] = useState(false);
  const [localLoaded, setLocalLoaded] = useState(false);
  const [noLocal, setNoLocal] = useState(false);
  const [searching, setSearching] = useState(false);
  const [showShopForm, setShowShopForm] = useState(false);
  const [joined, setJoined] = useState(false);

  const reportError = (error) => {
    console.error(error);
    setNoLocal(true);
    setSearching(false);
  };

  useEffect(() => {
    if (!profileGeo && !mount) {
      const getLocation = (navigator) => {
        navigator.geolocation.getCurrentPosition((position) => {
          setLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        }, reportError);
      };
      if (!location.lat && !mount) {
        getLocation(navigator);
      }
    }
    setMount(true);
  }, [location, mount, localLoaded, profileGeo]);

  useEffect(() => {
    if (profileGeo && !mount) {
      setLocation({
        lat: profileGeo[1],
        lng: profileGeo[0],
      });
      setMount(true);
    }
  }, [profileGeo, mount]);

  const getLocation = (navigator) => {
    setSearching(true);
    navigator.geolocation.getCurrentPosition((position) => {
      setLocalLoaded(false);
      setLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
      setSearching(false);
    }, reportError);
  };

  useEffect(() => {
    if (location.lat && !localLoaded) {
      // object to string
      const geo = `${location.lat},${location.lng}`;
      const criteria = { make };
      searchLocations(geo, criteria);
      setLocalLoaded(true);
    }
  }, [location, localLoaded, searchLocations, make]);

  // convert distance to miles
  const toMiles = (distance) => {
    return (distance * 0.000621371192).toFixed(0);
  };

  return (
    <div>
      <div className="flex flex-row justify-between">
        <h2>Find Local</h2>
        <button
          onClick={() => {
            getLocation(navigator);
          }}
          className={`btn btn-brand btn-xs gap-1 ${
            searching ? `animate-pulse` : ``
          }`}
        >
          <MapPinIcon
            className={`h-4 w-4 ${searching ? `animate-pulse` : ``}`}
          />
          {searching ? 'Searching...' : 'Search Near Me'}
        </button>
      </div>
      {local?.length > 0 ? (
        <>
          <small>
            These locations may stock or are able to special order this item.
          </small>
          <ul>
            {local.map(({ name: brand, locations, alias, dist }, index) => (
              <li key={index} className="my-3">
                <ul className="grid grid-cols-1 gap-4">
                  {locations.map(
                    ({ name, dist, email, address, phone }, index) => (
                      <li
                        className="border p-3 rounded-md shadow-md grid grid-cols-2 gap-x-6"
                        key={index}
                      >
                        <h4>
                          <Link to={`/${alias}`} className="link">
                            {brand} {name}
                          </Link>
                        </h4>
                        <div className="text-sm mt-0.5">
                          {dist && toMiles(dist)} miles
                        </div>
                        <div className="text-sm">{address}</div>
                        <div className="flex flex-col text-sm">
                          <div>{email}</div>
                          <div>{phone}</div>
                        </div>
                      </li>
                    )
                  )}
                </ul>
              </li>
            ))}
          </ul>
        </>
      ) : noLocal ? (
        <p>Geolocation deactivated</p>
      ) : !localLoaded ? (
        <p>Loading...</p>
      ) : (
        <p>No local places found</p>
      )}
      <div className="mt-4">
        {joined ? (
          <small>
            <i>Thanks — we'll be in touch about listing your shop.</i>
          </small>
        ) : !showShopForm ? (
          <small>
            <i>
              Own or manage a local bike shop that carries this make?{' '}
              <button
                type="button"
                className="link"
                onClick={() => setShowShopForm(true)}
              >
                List your shop
              </button>
            </i>
          </small>
        ) : (
          <Form
            onSubmit={async (formValues) => {
              const joinedOk = await joinStockistWaitlist({
                ...formValues,
                makeId: make?._id,
                makeName: make?.name,
                itemId,
                itemName,
              });
              if (joinedOk) {
                setShowShopForm(false);
                setJoined(true);
              }
            }}
            validate={(formValues) => {
              const errors = {};
              if (!formValues.shopName) {
                errors.shopName = 'Please enter your shop name';
              }
              if (!formValues.email) {
                errors.email = 'Please enter an email';
              } else if (
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)
              ) {
                errors.email = 'Please enter a valid email';
              }
              return errors;
            }}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <small>
                  <i>
                    Tell us about your shop and we'll be in touch to get you
                    listed{make?.name ? ` for ${make.name}` : ''}.
                  </i>
                </small>
                <Field
                  name="shopName"
                  component={CustomInput}
                  type="text"
                  size="input input-sm"
                  placeholder="Shop name"
                />
                <Field
                  name="email"
                  component={CustomInput}
                  type="text"
                  size="input input-sm"
                  placeholder="Email"
                />
                <Field
                  name="phone"
                  component={CustomInput}
                  type="text"
                  size="input input-sm"
                  placeholder="Phone (optional)"
                />
                <Field
                  name="message"
                  component="textarea"
                  placeholder="Anything we should know? (optional)"
                  className="textarea textarea-bordered w-full text-sm"
                />
                <div className="flex flex-row gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={submitting}
                  >
                    {submitting ? 'Sending...' : 'Submit'}
                  </button>
                  <button
                    type="button"
                    className="btn btn-ghost btn-sm"
                    onClick={() => setShowShopForm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const profileGeo = state.auth?.profile?.locationGeo?.coordinates;

  return {
    local: state.search.local,
    profileGeo,
  };
};

export default connect(mapStateToProps, {
  searchLocations,
  joinStockistWaitlist,
})(FindLocal);
